module.exports = __webpack_public_path__ + "static/media/brave-logo.88fbacb4.svg";